import { BottomSheetScrollView } from "@gorhom/bottom-sheet";
import { AHButton, AHIcon, AHText, Box } from "arkh";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { StartFocusModeButtonText } from "./StartFocusModeButtonText";

export function StartPrompt(props: {
  screens: {
    id: string;
    name: string;
  }[];
  hasOtherScreens: boolean;
  onChangeScreens: () => void;
  onAddScreen: () => void;
  onStartFocusMode: () => void;
}) {
  const intl = useIntl();
  return (
    <>
      <Box spaceHorizontal="large" spaceBottom="large">
        <AHText type="list-item-title" color="text-secondary" spaceTop="medium">
          <FormattedMessage
            defaultMessage="Your dashboard is connected to these screens."
            description="Focus Bottom Sheet Active Screens title"
          />
        </AHText>

        <AHText spaceTop="medium" type="title-small" spaceBottom="medium">
          <FormattedMessage
            defaultMessage="Active screens"
            description="Focus Bottom Sheet Active Screens list title"
          />
        </AHText>

        <BottomSheetScrollView
          contentContainerStyle={{ height: 60 }}
          horizontal
        >
          {props.screens.map((screen) => {
            return (
              <Box key={screen.id} spaceRight="small">
                <Box
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    minWidth: 100,
                  }}
                >
                  <AHIcon type="tv" color="primary" spaceRight="small" />
                  <AHText type="title-small" color="primary">
                    {screen.name}
                  </AHText>
                </Box>
              </Box>
            );
          })}
        </BottomSheetScrollView>
      </Box>
      <Box
        spaceTop="medium"
        spaceHorizontal="large"
        spaceBottom="medium"
        style={{ flex: 1, justifyContent: "flex-end" }}
      >
        <AHButton
          themeType="primary"
          title={<StartFocusModeButtonText />}
          onPress={props.onStartFocusMode}
        />
        <AHButton
          themeType="plain"
          title={
            <AHText type="subtitle" color="text-cta">
              {props.hasOtherScreens
                ? intl.formatMessage({
                    defaultMessage: "Use Another Screen",
                    description:
                      "Focus BS Start Prompt Use Another Screen button",
                  })
                : intl.formatMessage({
                    defaultMessage: "Setup New Screen",
                    description:
                      "Focus BS Start Prompt Install New Screen button",
                  })}
            </AHText>
          }
          onPress={
            props.hasOtherScreens ? props.onChangeScreens : props.onAddScreen
          }
        />
      </Box>
    </>
  );
}
